import React from "react";

const Benefits = () => (
  <section id="benefits">
    <h2>Why Choose Coir?</h2>
    <p>
      Coir is a natural, renewable resource that supports sustainable
      agriculture. It improves soil health, retains moisture, and reduces
      reliance on synthetic materials.
    </p>
    <div className="benefits-grid">
      <div className="benefit-card">
        <h3>♻️ Eco‑Friendly</h3>
        <p>Made from coconut husk, coir is biodegradable.</p>
      </div>
      <div className="benefit-card">
        <h3>💧 Soil Health</h3>
        <p>Improves aeration and water retention in soil.</p>
      </div>
      <div className="benefit-card">
        <h3>🪵 Durability</h3>
        <p>Strong and long‑lasting, perfect for gardening.</p>
      </div>
    </div>
  </section>
);

export default Benefits;
